const news = {
  'news.page.backToTop': 'ページの先頭へ戻る',
  'news.page.lastUpdated': '最終更新: 2026年6月13日',
  'news.page.homeLink': 'ホーム',
  'news.page.currentPage': 'お知らせ',

  'news.hero.homeLink': 'ホーム',
  'news.hero.currentPage': 'お知らせ',
  'news.hero.title': 'お知らせ',
  'news.hero.titleEn': 'NEWS',
  'news.hero.lead': '日本執事アカデミーからの最新のお知らせを掲載しています。開校日程や説明会、更新情報を随時お届けします。',
  'news.hero.imgAlt': '掲示板に最新の開校案内を貼り出す講師の様子',

  'news.list.empty': 'お知らせはまだありません。',
  'news.list.readMore': '続きを読む',
  'news.list.allLabel': 'すべて',
  'news.list.catSchedule': '開校情報',
  'news.list.catSeminar': '説明会',
  'news.list.catUpdate': '更新情報',
  'news.list.catOther': 'その他',

  'news.faq.label': 'FAQ',
  'news.faq.title': 'よくあるご質問',
  'news.faq.subtitleEn': 'Frequently Asked Questions',
  'news.faq.0.q': '開校日程はどこで分かりますか?',
  'news.faq.0.a': '決定し次第このお知らせ欄でご案内します。資料請求でも最新の予定をお届けします。',
  'news.faq.1.q': '説明会はありますか?',
  'news.faq.1.a': '開催が決まり次第こちらでご案内します。1日完結の体験講座もご用意しています。',
  'news.faq.2.q': '更新はどのくらいの頻度ですか?',
  'news.faq.2.a': '準備の進捗に合わせて随時更新します。',

  'news.subscribe.title': 'お知らせを受け取る',
  'news.subscribe.desc': '最新の開校情報・説明会案内は資料請求でお届けします。',
  'news.subscribe.btn': '資料請求はこちら',

  'news.related.label': 'LEARN MORE',
  'news.related.title': '関連ページ',
  'news.related.subtitleEn': 'Explore Further',
  'news.related.viewMore': '詳しく見る',
  'news.related.0.title': '資料請求',
  'news.related.0.description': '無料の資料をお届け',
  'news.related.1.title': 'コース一覧',
  'news.related.1.description': '3コースを比較',
  'news.related.2.title': 'お問い合わせ',
  'news.related.2.description': 'ご質問・ご相談の窓口',
};

export default news;
